<div [formGroup]="formGroup">
  <section>
    <div
      class="card mb-4"
      [ngClass]="
        submitted && formGroup.invalid
          ? 'border-danger border-2'
          : 'card-border-color-from-db'
      "
    >
      <div class="card-header card-header-color-from-db">
        {{ sectionHeader | translate }}
      </div>

      <div class="card-body">
        @let typeFormControl = getTypeFormControl();
        @let typeFormControlValue = typeFormControl?.value;
        @let typeAlertShouldBeVisible = submitted && !isTypeFormControlValid();
        @let isBuildingPermit =
          typeFormControlValue ===
          constructionPermitDocumentType.BuildingPermit;
        @let isConstructionNotification =
          typeFormControlValue ===
          constructionPermitDocumentType.ConstructionWorkNotifiction;

        @if (typeFormControl) {
          <div class="row" [ngClass]="{ 'mb-2': typeFormControlValue }">
            <div class="col-12">
              <div class="form-check form-check-inline">
                <input
                  class="form-check-input"
                  type="radio"
                  [id]="
                    idPrefix + constructionPermitDocumentType.BuildingPermit
                  "
                  [name]="controlName.Type"
                  [value]="constructionPermitDocumentType.BuildingPermit"
                  [formControlName]="controlName.Type"
                />
                <label
                  class="form-check-label"
                  [attr.for]="
                    idPrefix + constructionPermitDocumentType.BuildingPermit
                  "
                >
                  {{
                    'MONUMENT_CONSERVATION_GRANT_REQUEST.PERMIT_SECTION.BUILDING_PERMIT'
                      | translate
                  }}
                </label>
              </div>
              <div class="form-check form-check-inline">
                <input
                  class="form-check-input"
                  type="radio"
                  [id]="
                    idPrefix +
                    constructionPermitDocumentType.ConstructionWorkNotifiction
                  "
                  [name]="controlName.Type"
                  [value]="
                    constructionPermitDocumentType.ConstructionWorkNotifiction
                  "
                  [formControlName]="controlName.Type"
                />
                <label
                  class="form-check-label"
                  [attr.for]="
                    idPrefix +
                    constructionPermitDocumentType.ConstructionWorkNotifiction
                  "
                >
                  {{
                    'MONUMENT_CONSERVATION_GRANT_REQUEST.PERMIT_SECTION.CONSTRUCTION_NOTIFICATION'
                      | translate
                  }}
                </label>
              </div>

              @if (typeAlertShouldBeVisible) {
                <div class="alert alert-danger my-2">
                  {{ 'FIELD_REQUIRED' | translate }}
                </div>
              }
            </div>
          </div>
        }

        @if (!typeFormControl || isBuildingPermit) {
          <div class="row">
            <div class="col-12">
              <label
                class="text-nowrap"
                [attr.for]="idPrefix + controlName.IssuedBy"
              >
                {{
                  'MONUMENT_CONSERVATION_GRANT_REQUEST.PERMIT_SECTION.ISSUED_BY'
                    | translate
                }}
              </label>
              <input
                type="text"
                [name]="controlName.IssuedBy"
                [id]="idPrefix + controlName.IssuedBy"
                class="form-control form-control-sm required"
                aria-required="true"
                [formControlName]="controlName.IssuedBy"
              />
              @let issuedByAlertShouldBeVisible =
                submitted && !isIssuedByFormControlValid();
              @if (issuedByAlertShouldBeVisible) {
                <div class="alert alert-danger my-2">
                  {{ 'FIELD_REQUIRED' | translate }}
                </div>
              }
            </div>
          </div>
        }

        @if (!typeFormControl || typeFormControlValue) {
          <div class="row mt-2">
            @if (
              !typeFormControl || isBuildingPermit || isConstructionNotification
            ) {
              <div class="col-lg col-md-12">
                <label
                  class="text-nowrap"
                  [attr.for]="idPrefix + controlName.Date"
                >
                  {{
                    'MONUMENT_CONSERVATION_GRANT_REQUEST.PERMIT_SECTION.DATE'
                      | translate
                  }}
                </label>
                <div class="input-group">
                  <input
                    class="form-control form-control-sm required"
                    [attr.placeholder]="
                      'GK.DYNAMIC_LIST.DATE_PLACEHOLDER' | translate
                    "
                    [id]="idPrefix + controlName.Date"
                    [name]="controlName.Date"
                    [formControlName]="controlName.Date"
                    ngbDatepicker
                    #datePicker="ngbDatepicker"
                  />
                  <button
                    class="btn btn-outline-secondary fa fa-calendar"
                    (click)="datePicker.toggle()"
                    type="button"
                  ></button>
                </div>
                @let dateFormControlAlertShouldBeVisible =
                  submitted && !isDateFormControlValid();
                @if (dateFormControlAlertShouldBeVisible) {
                  <div class="alert alert-danger my-2">
                    {{ 'FIELD_REQUIRED' | translate }}
                  </div>
                }
              </div>
            }
            @if (!typeFormControl || isBuildingPermit) {
              <div class="col-lg col-md-12">
                <label
                  class="text-nowrap"
                  [attr.for]="idPrefix + controlName.Number"
                >
                  {{
                    'MONUMENT_CONSERVATION_GRANT_REQUEST.PERMIT_SECTION.NUMBER'
                      | translate
                  }}
                </label>
                <input
                  type="text"
                  [name]="controlName.Number"
                  [id]="idPrefix + controlName.Number"
                  class="form-control form-control-sm required"
                  aria-required="true"
                  [formControlName]="controlName.Number"
                />
                @let numberAlertShouldBeVisible =
                  submitted && !isNumberFormControlValid();
                @if (numberAlertShouldBeVisible) {
                  <div class="alert alert-danger my-2">
                    {{ 'FIELD_REQUIRED' | translate }}
                  </div>
                }
              </div>
            }
          </div>
        }
      </div>
    </div>
  </section>
</div>
